import { render, staticRenderFns } from "./suSummary.vue?vue&type=template&id=3d4884e3"
import script from "./suSummary.vue?vue&type=script&lang=js"
export * from "./suSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports